"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakerType = void 0;
var BreakerType;
(function (BreakerType) {
    BreakerType["AMP_15"] = "amp15";
    BreakerType["AMP_20"] = "amp20";
    BreakerType["AMP_30"] = "amp30";
    BreakerType["AMP_40"] = "amp40";
})(BreakerType = exports.BreakerType || (exports.BreakerType = {}));
